<template>
  <v-container
    v-if="isLoading"
    class="d-flex justify-center align-center"
    :style="{ height: '100svh' }"
  >
    <v-progress-circular
      indeterminate
      color="primary"
      size="65"
    ></v-progress-circular>
  </v-container>
</template>

<script>
import { utils, writeFile } from "xlsx";
import axios from "axios";

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  mounted() {
    this.process();
  },
  methods: {
    async process() {
      try {
        this.isLoading = true;

        const {
          tab,
          memberId,
          description,
          datefrom,
          dateto,
        } = this.$route.query;

        const [data] = await axios
          .get(`${this.serverUrl}yasale/reward-points-transaction`, {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: {
              tab,
              memberId,
              description,
              datefrom,
              dateto,
              limit: Number.MAX_SAFE_INTEGER,
              offset: 0,
            },
          })
          .then((response) => response.data.data);

        const { campaignList, imeiList } = data;

        const rows = [
          ["ชื่อเครื่อง", "IMEI", "จำนวนเครื่องที่ได้รับ", "เวลา"],
          ...campaignList.map((item) => [
            item.description || "",
            item.imei || "",
            +item.points || 0,
            item.timestamp ? new Date(item.timestamp) : "",
          ]),
          ...imeiList.map((item) => [
            item.description || "",
            item.imei || "",
            +item.points || 0,
            item.timestamp ? new Date(item.timestamp) : "",
          ]),
        ];

        const worksheet = utils.aoa_to_sheet(rows, {
          dateNF: "d/m/yyyy h:mm:ss",
        });
        worksheet["!cols"] = [
          { wch: 50 },
          { wch: 15 },
          { wch: 10 },
          { wch: 20 },
        ];
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "point-history");
        writeFile(workbook, `yas-point-history-${Date.now()}.xlsx`);
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
